import { api } from './client.js';

type ClientEvent =
  | 'finding_viewed'
  | 'diy_steps_opened'
  | 'service_request_opened'
  | 'upgrade_clicked'
  | 'alert_email_clicked'
  | 'report_email_clicked';

/** Product event (own table, PRD §8); fire and forget, never blocks or breaks the UI. */
export function track(
  event: ClientEvent,
  props: {
    ruleCode?: string;
    serviceCode?: string;
    category?: string;
    source?: string;
    plan?: string;
  } = {},
): void {
  void api.POST('/events', { body: { event, props } }).catch(() => undefined);
}
